import { render, staticRenderFns } from "./vendorAssessTarget.vue?vue&type=template&id=283567a4"
import script from "./vendorAssessTarget.vue?vue&type=script&lang=js"
export * from "./vendorAssessTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283567a4')) {
      api.createRecord('283567a4', component.options)
    } else {
      api.reload('283567a4', component.options)
    }
    module.hot.accept("./vendorAssessTarget.vue?vue&type=template&id=283567a4", function () {
      api.rerender('283567a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/csm/vendorAssessTarget.vue"
export default component.exports